import React, { useState, useRef } from 'react';
import Styles from './window.module.css';
import Min from '../images/Minimize.png';
import Maximize from '../images/Maximize.png';
import Close from '../images/Exit.png';
import WindowDimensions from '../hooks/WindowDimensions';

export default function Window({ win, onClose, onMinimize, onToggleMaximize, bringToFront }) {

  let { height, width } = WindowDimensions();
  height = height - 50;
  width = width - 4;

  const windowRef = useRef(null);

  const [pos, setPos] = useState({
    x: window.innerWidth * 0.20,
    y: window.innerHeight * 0.20
  });

  const dragging = useRef(false);
  const offset = useRef({ x: 0, y: 0 });

  function handleMouseDown(e) {
    if (win.maximized) return;

    bringToFront();

    dragging.current = true;
    offset.current = {
      x: e.clientX - pos.x,
      y: e.clientY - pos.y
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  }

  function handleMouseMove(e) {
    if (!dragging.current) return;

    setPos({
      x: e.clientX - offset.current.x,
      y: e.clientY - offset.current.y
    });
  }

  function handleMouseUp() {
    dragging.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  }

  return (
    <section
      ref={windowRef}
      className={`${Styles.window} ${win.maximized ? Styles.maximized : ""}`}
      onMouseDown={bringToFront}
      style={{
        "--winHeight": `${height}px`,
        "--winWidth": `${width}px`,
        top: win.maximized ? 0 : `${pos.y}px`,
        left: win.maximized ? 0 : `${pos.x}px`,
        zIndex: win.zIndex
      }}
    >

      <div className={Styles.head} onMouseDown={handleMouseDown}>
        <div className={Styles.LeftSide}>
          
          <div
            className={Styles.headIcon}
            style={{
              backgroundImage: `url(${win.icon})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center'
            }}
          ></div>

          <div className={Styles.headTitle}>{win.title}</div>
        </div>

        <div className={Styles.RightSide}>

          <div
            className={Styles.minimize}
            style={{ backgroundImage: `url(${Min})`, cursor: "pointer" }}
            onClick={onMinimize}
          ></div>

          <div
            className={Styles.maximize}
            onClick={onToggleMaximize}
            style={{
              backgroundImage: `url(${Maximize})`,
              cursor: "pointer"
            }}
          ></div>

          <div
            className={Styles.close}
            onClick={onClose}
            style={{
              backgroundImage: `url(${Close})`,
              cursor: "pointer"
            }}
          ></div>

        </div>
      </div>

      <div className={Styles.body}>
        {win.content}
      </div>
    </section>
  );
}
